import { Device } from '@e2m-customer-portal/hooks';
import { Nullable } from '@e2m-customer-portal/shared';

export const getDisplayName = (device: Nullable<Device>): string | undefined => {
  if (!device) {
    return undefined;
  }

  if (!device.externalName || device.externalName === '') {
    return device.name;
  }

  return device.externalName;
};
